

// 📱 hooks/useDeviceDetection.js
// Hook unifié pour détecter le type d'appareil
import { useEffect, useState } from "react";

// ✅ Fonction helper pour détecter le device (utilisable côté serveur)
const getDeviceInfo = () => {
  // Protection SSR
  if (typeof window === "undefined") {
    return {
      isMobile: false,
      isTouch: false,
      isPortrait: false,
      viewport: { width: 0, height: 0 },
    };
  }

  const width = window.innerWidth;
  const height = window.innerHeight;

  return {
    // Mobile si largeur < 768px OU user agent mobile
    isMobile:
      width <= 767 || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent),

    // Écran tactile (pas de hover)
    isTouch: window.matchMedia("(hover: none)").matches,

    // Orientation portrait
    isPortrait: height >= width,

    // Dimensions viewport
    viewport: { width, height },
  };
};

export const useDeviceDetection = () => {
  // ✅ Initialisation avec la vraie valeur dès le départ
  const [deviceInfo, setDeviceInfo] = useState(getDeviceInfo);

  useEffect(() => {
    const checkDevice = () => {
      setDeviceInfo(getDeviceInfo());
    };

    // Mise à jour sur resize
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return deviceInfo;
};